import * as React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import makeStyles from '@material-ui/core/styles/makeStyles';
import createStyles from '@material-ui/core/styles/createStyles';
import { Theme } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import { Button } from '@material-ui/core';
import GetAppIcon from '@material-ui/icons/GetApp';

export interface PrintClientViewProps {

}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            // height: 'calc(100vh - 13px)'
            backgroundColor: '#50D6D9'
        },
        innerText: {
            backgroundColor: '#50D6D9',
            // height: '100vh'
        },
        center: {
            height: '80vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column'
        },
        image: {
            maxHeight: '180px'
        },
        text: {
            fontWeight: 300,
            color: '#fff',
            textAlign: 'center'
        },
        paragraph: {
            color: '#fff',
            textAlign: 'center',
            fontSize: 20,
            fontWeight: 500,
        }
    }),
);

const PrintClientView: React.FC<PrintClientViewProps> = props => {
    const classes = useStyles({});
    return (
        <div className={classes.root}>
            <CssBaseline />
            <Container fixed>
                <div className={classes.innerText}>
                    <div className={classes.center}>
                        <img src="/assets/printclient.jpg" alt="error page" className={classes.image} />
                        <Typography variant="h4" gutterBottom className={classes.text}>
                            Looks like you haven't installed the Print client.
                        </Typography>
                        <Typography variant="h4" gutterBottom className={classes.text}>
                            Please install the client from this location and try again
                        </Typography>
                        <Button variant="outlined" component="a" target="_blank" href="https://google.com" endIcon={<GetAppIcon fontSize="small" />}>
                            Install MLC-Envisiontec Print Client
                        </Button>
                    </div>
                </div>
            </Container>
        </div>
    );
};

export default PrintClientView;



// WEBPACK FOOTER //
// ./src/components/layouts/PrintClientErrorView.tsx